import { Auth0Provider as Auth0Provider } from '@auth0/auth0-react';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Companion_instance258n8f26mwg1r as Companion_instance } from '../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/external/w3c/WindowFunctions.mjs';
import { endsWith3cq61xxngobwh as endsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { SessionConfig_instance2hcjnhl8ta2bu as SessionConfig_instance } from './SessionConfig.mjs';
import { CouplingRouter5mycb1oqjg80 as CouplingRouter } from './routing/CouplingRouterKt.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_RootComponent() {
  _init_properties_RootComponent_kt__yjjsy1();
  var tmp = KProperty0();
  return RootComponent$delegate.f1m(null, getPropertyCallableRef('RootComponent', 0, tmp, _get_RootComponent_$ref_9gohz9(), null));
}
var RootComponent$delegate;
function isCallbackFromOtherProvider() {
  _init_properties_RootComponent_kt__yjjsy1();
  return endsWith(Companion_instance.t3q().location.pathname, '/integration/slack/callback') || endsWith(Companion_instance.t3q().location.pathname, '/integration/discord/callback');
}
function RootComponent$delegate$lambda($this$nfc, props) {
  _init_properties_RootComponent_kt__yjjsy1();
  var config = props.clientConfig;
  setDefaultKey($this$nfc, '@rdk/17_4');
  var tmp2 = Auth0Provider;
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$Auth0Provider) => {
    $this$Auth0Provider.clientId = config.x7i_1;
    $this$Auth0Provider.domain = config.y7i_1;
    $this$Auth0Provider.cacheLocation = 'localstorage';
    // Inline function 'com.zegreatrob.coupling.client.components.external.auth0.react.Auth0AuthorizationParams.Companion.invoke' call
    // Inline function 'com.zegreatrob.coupling.client.components.external.auth0.react.com_zegreatrob_coupling_client_components_external_auth0_react_Auth0AuthorizationParams_Companion_erww2t_invoke_jkqnwo' call
    $this$Auth0Provider.authorizationParams = {redirect_uri: Companion_instance.t3q().location.origin + config.z7i_1, audience: 'https://' + Companion_instance.t3q().location.hostname + '/api', scope: 'email'};
    $this$Auth0Provider.skipRedirectCallback = isCallbackFromOtherProvider();
    $this$Auth0Provider.useRefreshTokens = true;
    CouplingRouter($this$Auth0Provider, SessionConfig_instance.h7j(), SessionConfig_instance.i7j(), config);
    return Unit_instance;
  };
  addChild($this$nfc, tmp2, block);
  return Unit_instance;
}
function _get_RootComponent_$ref_9gohz9() {
  return constructCallableReference(() => get_RootComponent(), 0, 0, 249);
}
var properties_initialized_RootComponent_kt_360zhx;
function _init_properties_RootComponent_kt__yjjsy1() {
  if (!properties_initialized_RootComponent_kt_360zhx) {
    properties_initialized_RootComponent_kt_360zhx = true;
    RootComponent$delegate = nfc(RootComponent$delegate$lambda);
  }
}
//region block: exports
export {
  get_RootComponent as get_RootComponentir94du7iar4c,
};
//endregion

//# sourceMappingURL=RootComponent.mjs.map
